import Access from "constants/Access";

const ERP_PLAN = 'module_erp';

const getRootLocations = (rootState) => (
	Array.isArray(rootState?.locations) ? rootState.locations : []
);

const getActiveLocations = (locations) => {
	const activeLocations = locations.filter((location) => !location?.archived);
	return activeLocations.length > 0 ? activeLocations : locations;
};

const getLocationModules = (location) => (
	Array.isArray(location?.location_moduless) ? location.location_moduless : []
);

export const locationHasModulePlan = (location, plan) => (
	getLocationModules(location).some((entry) => {
		const moduleData = entry?.modules ?? entry;
		return moduleData?.plan === plan;
	})
);

export const getErpAccessibleLocations = (rootState) => {
	const locations = getActiveLocations(getRootLocations(rootState));
	const erpLocations = locations.filter((location) => locationHasModulePlan(location, ERP_PLAN));
	if (erpLocations.length > 0) {
		return erpLocations;
	}

	const hasLocationModuleData = locations.some((location) => getLocationModules(location).length > 0);
	if (hasLocationModuleData) {
		return [];
	}

	return rootState?.hasErpModule ? locations : [];
};

export const canAccessErp = (rootState) => {
	const userAccess = Number(rootState?.userAccess);
	return Number.isFinite(userAccess)
		&& userAccess <= Access.Employee
		&& getErpAccessibleLocations(rootState).length > 0;
};
